import { openStackMap as openStackMapGA } from '@bibliocommons/ga-event-templates';
import StackMapApi from 'app/api/StackMapApi';
import StackMapConstants from 'app/constants/StackMapConstants';

function openStackMap(stackMap, item) {
  return {
    types: [StackMapConstants.REQUEST, StackMapConstants.SUCCESS, StackMapConstants.FAILURE],
    middlewareData: {
      gaEvent: openStackMapGA(item.get('callNumber'))
    },
    apiRequest: () =>
      StackMapApi.fetchMap(stackMap.get('domain'), {
        location: item.get('collection'),
        callno: item.get('callNumber'),
        library: item.getIn(['branch', 'name'])
      }),
    apiFailure: () => ({
      messaging: null
    })
  };
}

function closeStackMap() {
  return {
    type: StackMapConstants.CLOSE
  };
}

export default {
  openStackMap,
  closeStackMap
};
